import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import GeneralFilterBarDivider from 'lumen/components/general/filter-bar/divider';
import HotelAndMarketDropdownsAccountSelector from 'lumen/components/hotel-and-market/dropdowns/account-selector';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';

interface HotelAndMarketDropdownsAccountSelectorWrapperSignature {
  Args: {
    hasDivider?: boolean;
  };
}

export default class HotelAndMarketDropdownsAccountSelectorWrapper extends Component<HotelAndMarketDropdownsAccountSelectorWrapperSignature> {
  @service declare featureToggle: Services['feature-toggle'];
  @service declare navigation: Services['navigation'];
  @service declare router: Services['router'];

  get hasMultipleAccounts(): boolean {
    const subscriptions = this.navigation.getSubscriptionsForRoute(
      this.router.currentRouteName!,
    );

    return subscriptions.length > 1;
  }

  get shouldRender(): boolean {
    return (
      this.featureToggle.hasFeatureToggle(FEATURE_TOGGLES.UNIFIED_HOTEL_VIEW) &&
      this.hasMultipleAccounts
    );
  }

  <template>
    {{#if this.shouldRender}}
      <div class="flex items-center gap-400">
        <HotelAndMarketDropdownsAccountSelector />
        {{#if @hasDivider}}
          <GeneralFilterBarDivider />
        {{/if}}
      </div>
    {{/if}}
  </template>
}
